import "./DashboardTradingAlertsComponent.scss";
import {IComponentOptions, IOnDestroy, IOnInit} from "angular";
import {TradingAlertService} from "../../../../trading-alerts/services/TradingAlertService";
import {TradingAlertViewStore} from "../../../../trading-alerts/view-store/TradingAlertViewStore";
import {Observable, ReplaySubject} from "rxjs";
import {TradingAlert} from "../../../../trading-alerts/models/alert/TradingAlert";
import {TradingAlertDialogService} from "../../../../trading-alerts/services/TradingAlertDialogService";
import {SystemEventService} from "../../../../services/system-state/SystemEventService";
import {TradingAlertViewDialogService} from "../../../../trading-alerts/services/TradingAlertViewDialogService";
import {CurrentUserService} from "../../../../services/user/CurrentUserService";

export const TradingAlerts = "tfDashboardTradingAlerts";

export function tradingAlerts(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/trading-alerts/DashboardTradingAlertsComponent.html`,
        controllerAs: "ctrl",
        controller: DashboardTradingAlertsComponentController
    };
}

export class DashboardTradingAlertsComponentController implements IOnInit, IOnDestroy {

    public alerts$: Observable<Array<TradingAlert>>;

    private readonly viewStore: TradingAlertViewStore;
    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(tradingAlertService: TradingAlertService,
                       tradingAlertDialogService: TradingAlertDialogService,
                       systemEventService: SystemEventService,
                       currentUserService: CurrentUserService) {
        this.viewStore = new TradingAlertViewStore(tradingAlertService,
                                                   tradingAlertDialogService,
                                                   systemEventService,
                                                   currentUserService);
    }

    public $onInit(): void {
        this.alerts$ = this.allAlerts();
    }

    private allAlerts(): Observable<Array<TradingAlert>> {
        return Observable.combineLatest(this.viewStore.matchedAlerts(), this.viewStore.activeAlerts())
                         .takeUntil(this.destroyed$)
                         .map(([matched, active]) => matched.concat(active));
    }

    public addAlert() {
        this.viewStore.addAlert();
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
        this.viewStore.destroy();
    }
}
